let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3VsAL")).then(() => parcelRequire('e6XZn'));